import { HiSun, HiEye, HiSparkles, HiScissors, HiExternalLink } from 'react-icons/hi';
import HeroSection from '../components/ui/HeroSection';
import { SectionHeader } from '../components/ui/Section';
import ChalkboardBackground from '../components/ui/ChalkboardBackground';
import Card, { CardContent } from '../components/ui/Card';
import Button from '../components/ui/Button';
import comingSoon from '../data/comingSoon.json';
import siteContent from '../data/siteContent.json';
import homeBg from '../assets/images/bb-background.png';
import comingSoonBg from '../assets/images/coming-soon-banner.png';
import Seo from '../components/Seo';

const iconMap = {
  sun: HiSun,
  eye: HiEye,
  eyebrow: HiSparkles,
  sparkles: HiSparkles,
  scissors: HiScissors,
};

export default function ComingSoon() {
  return (
    <>
      <Seo
        title="Coming Soon"
        description="New services coming soon from Blush & Bobby bridal beauty in Kansas City."
        path="/coming-soon"
        noindex
      />
      {/* Hero */}
      <HeroSection title="Coming Soon" backgroundImage={comingSoonBg} />

      {/* Services */}
      <ChalkboardBackground className="py-20">
        <div className="container-custom">
          <SectionHeader
            title="New Services on the Horizon"
            subtitle="Expand your bridal beauty experience"
            dark={true}
          />
          <div className="flex flex-wrap justify-center gap-6 max-w-5xl mx-auto">
            {comingSoon.services.map((service) => {
              const Icon = iconMap[service.icon] || HiSparkles;
              return (
                <Card
                  key={service.name}
                  className="p-6 text-center w-full md:w-[calc(50%-1.5rem)] lg:w-[calc(33.333%-1.5rem)]"
                >
                  <CardContent className="p-0">
                    <div className="inline-flex items-center justify-center w-12 h-12 border border-dusty-rose/20 rounded-full mb-4">
                      <Icon className="h-6 w-6 text-dusty-rose" />
                    </div>
                    <h3 className="font-semibold mb-2 text-chalk">{service.name}</h3>
                    <p className="text-white/80 text-sm leading-relaxed">{service.description}</p>
                  </CardContent>
                </Card>
              );
            })}
          </div>
        </div>
      </ChalkboardBackground>

      {/* Final CTA */}
      <ChalkboardBackground 
        as="section" 
        backgroundImage={homeBg}
        backgroundOpacity={0.5}
        className="py-12 md:py-16 lg:py-20"
      >
        <div className="container-custom">
          <div className="text-center max-w-2xl mx-auto">
            <h2 className="text-2xl md:text-3xl lg:text-4xl font-headline font-semibold mb-6 text-chalk uppercase tracking-wider">
              Let's Create Your Dream Look
            </h2>
            <Button
              href={siteContent.social.linktree}
              target="_blank"
              rel="noopener noreferrer"
              variant="outline"
              size="lg"
              className="!text-xs"
            >
              Check Availability
              <HiExternalLink className="ml-2 h-4 w-4" />
            </Button>
          </div>
        </div>
      </ChalkboardBackground>
    </>
  );
}
